import { Zap, MapPin, Building2, ShieldCheck } from "lucide-react";

const items = [
  { icon: Zap, label: "Fast Quotes" },
  { icon: MapPin, label: "Melbourne Based" },
  { icon: Building2, label: "Residential & Commercial" },
  { icon: ShieldCheck, label: "Reliable Workmanship" },
];

const TrustStrip = () => (
  <section className="bg-[#111111] py-4 md:py-5">
    <div className="container">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 max-w-3xl mx-auto">
        {items.map((item) => (
          <div
            key={item.label}
            className="group flex flex-col items-center gap-1.5 cursor-default"
          >
            <div className="relative w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center bg-[#FFC300]/8 backdrop-blur-md border border-[#FFC300]/15 shadow-[0_0_12px_rgba(255,195,0,0.06)] transition-all duration-300 group-hover:shadow-[0_0_18px_rgba(255,195,0,0.15)] group-hover:scale-105 group-hover:bg-[#FFC300]/12">
              <div className="absolute inset-0.5 rounded-full bg-gradient-to-b from-white/[0.07] to-transparent pointer-events-none" />
              <item.icon className="w-5 h-5 md:w-6 md:h-6 text-[#FFC300] relative z-10" strokeWidth={1.8} />
            </div>
            <span className="text-xs md:text-sm font-bold text-white/90 tracking-wide text-center">
              {item.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TrustStrip;
